import AbstractNormalizersResolver from "../../core/AbstractNormalizersResolver";
import SwitchPricingNormalizer from "./SwitchPricingNormalizer";
export default class SwitchPricingNormalizersResolver extends AbstractNormalizersResolver {
    register() {
        return [
            new SwitchPricingNormalizer(),
        ];
    }
}
